<div class="login-container">
  <h2>Login</h2>
  <form (ngSubmit)="onSubmit()" #loginForm="ngForm">    
    <div class="usertype-container">
      <label class="radio-pill">
        <input type="radio" name="usertype" [(ngModel)]="loginRequest.usertype" value="Vendor" required />
        <span>Vendor</span>
      </label>
      <label class="radio-pill">
        <input type="radio" name="usertype" [(ngModel)]="loginRequest.usertype" value="Employee" required />
        <span>Employee</span>
      </label>
    </div>   
    <div class="error" *ngIf="loginForm.submitted && !loginRequest.usertype">
      <small>Please select a user type.</small>
    </div>
    <div class="form-group">
      <input type="text" placeholder="User Name" name="login" [(ngModel)]="loginRequest.login" required minlength="3"
        #usernameCtrl="ngModel" />
      <div class="error" *ngIf="usernameCtrl.invalid && (usernameCtrl.touched || loginForm.submitted)">
        <small *ngIf="usernameCtrl.errors?.['required']">User name required.</small>
      </div>
    </div>   
    <div class="form-group">
      <input type="password" placeholder="Password" name="password" [(ngModel)]="loginRequest.password" required
        minlength="3" #passwordCtrl="ngModel" />
      <div class="error" *ngIf="passwordCtrl.invalid && (passwordCtrl.touched || loginForm.submitted)">
        <small *ngIf="passwordCtrl.errors?.['required']">Password required.</small>
      </div>
    </div>    
    <button type="submit" [disabled]="!loginForm.form.valid || isLoading">
      <span *ngIf="!isLoading">Login</span>
      <span *ngIf="isLoading" class="loader"></span>
    </button>
  </form>
  <div class="signup-option">
    Don’t have an account?
    <a href="/registration">Sign up</a>
  </div>
  <div class="signup-option">
    Rest Password
    <a href="/reset-password">Reset Password</a>
  </div>
</div>